
import { DynamicFormItemProps } from "@/pages/trade/components/DynamicForm/DynamicForm"

  
export const formItems: DynamicFormItemProps[] = [
    {fieldLabel: '账变时间', fieldName: 'createTime', placeholder: ' ', fieldType: '1', readOnly: true },
    {fieldLabel: '账变类型', fieldName: 'typeName', placeholder: ' ', fieldType: '1', readOnly: true },
    {fieldLabel: '账变金额', fieldName: 'amount', placeholder: ' ', fieldType: '1', readOnly: true },
    {fieldLabel: '收款用户昵称', fieldName: 'receiverNickName', fieldType: 'CopyIcon'},
    {fieldLabel: '付款用户昵称', fieldName: 'payNickName', fieldType: 'CopyIcon'},
    {fieldLabel: '账变流水号', fieldName: 'businessNo', fieldType: 'CopyIcon'},
]
  

